module.exports = __webpack_public_path__ + "img/AboutUs.ce3d9a9b.png";